import styled from 'styled-components'

const Box = styled.div`
  position: relative;
  min-height: 40px;
  padding: 12px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  /* whisper-thin fill: enough to lift the box off the page, weak enough that
     nesting one inside a modal surface doesn't muddy it */
  background: rgba(255, 255, 255, 0.02);
  box-shadow: 0 12px 32px -20px rgba(0, 0, 0, 0.8), inset 0 1px 0 rgba(255, 255, 255, 0.03);
  transition: border-color 200ms ease, box-shadow 200ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const EBox = (props: any) => {
  return <Box {...props}>{props.children}</Box>
}

export default EBox
